<template>
  <div id="document-management" class="h-full">
    <!-- 表格部分 -->
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <!-- 表头搜索 -->
      <el-row type="flex" align="middle">
        <selectStandardId @updateStandardId="updateStandardId" />
        <el-input
          @keyup.enter.native="searchList"
          size="small"
          clearable
          :placeholder="`${$t('SearchForDocumentNameOrEncoding')}`"
          v-model.trim="mainTableParam.keyWord"
          class="w-200px mr-10px ml-10px"
        ></el-input>
        <el-select
          v-if="isDocList"
          v-model="mainTableParam.category"
          :placeholder="$t('PleaseSelectACategory')"
          class="w-200px mr-10px"
          size="small"
          multiple
          collapse-tags
          filterable
          clearable
        >
          <el-option
            v-for="item in classTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button size="small" type="primary" @click="searchList">{{ $t('search') }}</el-button>
        <el-button v-if="isDocList" type="primary" @click="toMoreSearch">高级查询</el-button>
        <el-button :disabled="!$hasAccess('create')" type="primary" @click="addCategory(null)">{{
          $t('new')
        }}</el-button>
        <el-button
          :disabled="!$hasAccess('delete') || disabledBatchBtn"
          type="danger"
          :loading="delLoading"
          @click="toDelete()"
          >{{ $t('delete') }}</el-button
        >
        <el-button
          :disabled="!$hasAccess('export')"
          @click="handleGetExcel"
          :loading="exportLoading"
        >
          {{ $t('export') }}
        </el-button>
        <el-button :disabled="!$hasAccess('import')" @click="importFile">
          {{ $t('import') }}
        </el-button>
        <el-button :disabled="!$hasAccess('uploadFile')" @click="uploadDocFile">{{
          $t('uploadFiles')
        }}</el-button>
        <el-button
          :disabled="!$hasAccess('downloadFile')"
          @click="handleDownFile"
          :loading="downloading"
        >
          {{ $t('DownloadFiles') }}
        </el-button>
        <el-button
          :disabled="!$hasAccess('downloadFile')"
          @click="tableTypeChange"
          :loading="downloading"
        >
          <!-- {{ isDocList ? '文件清单' : '文档清单' }} -->
          {{ isDocList ? $t('fileLists') : $t('documentLists') }}
        </el-button>
        <!-- <columnVisible
          :options="columnVisibleOptions"
          class="dib ml-10px"
          :defaultValue="columnVisible"
          @columnVisibleChanged="handleColumnVisibleChanged"
          :name="['handoverDocument']"
        ></columnVisible> -->
      </el-row>
      <multipane style="height: calc(100% - 56px)" class="mt-20px">
        <!-- 左侧目录树结构 -->
        <div class="h-full" :style="{ minWidth: '300px', maxWidth: '600px' }">
          <el-card class="box-card h-full" :body-style="{ height: 'calc(100% - 45px)' }">
            <span slot="header">
              {{ `${$t('directoryTree')}` }}
            </span>
            <div class="flex">
              <el-input
                @keyup.enter.native="getCurrentTree"
                size="small"
                clearable
                :placeholder="`${$t('PleaseSearchForTheName')}`"
                v-model.trim="treeKeyWord"
              ></el-input>
              <el-button
                :disabled="!$hasAccess('create')"
                type="primary"
                class="ml-10px"
                @click.stop="() => append()"
                >{{ $t('create') }}</el-button
              >
            </div>
            <div class="tree mt-10px">
              <el-tree
                id="documentMenuTree"
                ref="documentMenuTree"
                highlight-current
                :data="currentTree"
                @node-click="handleDocNodeClick"
                @node-expand="nodeExpand"
                @node-collapse="nodeCollapse"
                :props="defaultTreeProps"
                :default-expanded-keys="initExpandList"
                v-if="treeStandBy"
                node-key="id"
                class="fz-14"
                :lazy="!isExpandAll"
                :default-expand-all="isExpandAll"
                :load="lazyNode"
              >
                <span slot-scope="{ node, data }" class="w-full">
                  <div class="d-flex flex-align-center flex">
                    <el-tooltip :content="node.label" :open-delay="1000" placement="top">
                      <p
                        class="flex-1 ell truncate"
                        style="width: 80px; line-height: 25px"
                        :class="{
                          blueText: treeKeyWord
                            ? node.label.indexOf(treeKeyWord) !== -1 ||
                              node.label.indexOf(treeKeyWord.toLowerCase()) !== -1
                            : false,
                        }"
                      >
                        {{ node.label }}<span class="text-color-red">({{ data.fileCount }})</span>
                      </p>
                    </el-tooltip>
                    <el-dropdown @command="($event) => handleCommand($event, node, data)">
                      <span class="el-dropdown-link">
                        <i class="iconfont icon-line-moreVertical text-14px font-bold"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="add" v-if="$hasAccess('create')">{{
                          $t('create')
                        }}</el-dropdown-item>
                        <el-dropdown-item command="edit" v-if="$hasAccess('update')">{{
                          $t('edit')
                        }}</el-dropdown-item>
                        <el-dropdown-item command="delete" v-if="$hasAccess('delete')">{{
                          $t('delete')
                        }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </span>
              </el-tree>
            </div>
          </el-card>
        </div>
        <multipane-resizer></multipane-resizer>
        <!-- 文档清单列表 -->
        <div :style="{ flexGrow: 1 }" class="ml-20px" v-if="tableType === 'docList'">
          <el-table
            ref="multipleTable"
            :data="dataList"
            v-loading="listLoading"
            height="calc(100% - 48px)"
            :highlight-current-row="true"
            @row-dblclick="addCategory"
            @row-click="rowClick"
            @sort-change="sortChange"
            @header-click="handleHeaderClick"
            @selection-change="selectionChange"
            style="position: absolute; top: 0; left: 0"
            row-key="id"
            stripe
            border
          >
            <el-table-column
              v-if="tableHeader.length > 0"
              type="selection"
              :reserve-selection="true"
              width="55"
            ></el-table-column>
            <el-table-column
              v-if="tableHeader.length > 0"
              type="index"
              width="80"
              :label="`${$t('serialNumber')}`"
            >
              <template slot-scope="scope">
                <el-tooltip placement="top" v-if="scope.row.check_out_user_id">
                  <div slot="content">
                    <div>检出人：{{ scope.row.check_out_user_name }}</div>
                    <div>检出时间：{{ scope.row.check_out_time }}</div>
                  </div>
                  <span class="el-icon-lock mr-5px"></span>
                </el-tooltip>
                <span>
                  {{ scope.$index + 1 + (mainTableParam.pageno - 1) * mainTableParam.pagesize }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              v-for="(val, index) in tableHeader"
              :key="index"
              :prop="`${val.tableName}.${val.columnName}`"
              :sortable="val.name === '类别' ? false : true"
              :label="val.name"
              :min-width="val.columnName === 'code' || val.columnName === 'name' ? '200' : '150'"
              :show-overflow-tooltip="!(val.columnName === 'code' || val.columnName === 'name')"
              stripe
            >
              <template slot-scope="scope">
                <div
                  :class="{ truncate: !(val.columnName === 'code' || val.columnName === 'name') }"
                >
                  {{ scope.row[`${val.tableName}.${val.columnName}`]
                  }}<span v-if="val.unit">{{ val.unit }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="`${$t('operate')}`"
              width="310"
              fixed="right"
              v-if="tableHeader.length > 0"
            >
              <template slot-scope="scope">
                <el-button
                  :disabled="!$hasAccess('read')"
                  :loading="scope.row.loading"
                  @click="handleClickDocument(scope.row, 1)"
                  size="mini"
                  >{{ $t('BrowsingDocuments') }}</el-button
                >
                <el-button
                  :disabled="!$hasAccess('update') || !!scope.row.check_out_user_id"
                  @click="addCategory(scope.row)"
                  size="mini"
                  >{{ $t('edit') }}</el-button
                >
                <el-button
                  :disabled="!$hasAccess('delete') || !!scope.row.check_out_user_id"
                  size="mini"
                  @click="toDelete([scope.row])"
                  >{{ $t('delete') }}</el-button
                >
                <el-dropdown
                  trigger="click"
                  @command="($event) => toMoreList($event, scope.row)"
                  class="ml-10px"
                  size="mini"
                >
                  <el-button size="mini" :loading="dropdownLoading">
                    {{ $t('more') }}<i class="iconfont icon-app-next text-12px"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="upgrade" :disabled="!!scope.row.check_out_user_id">{{
                      $t('UpgradeVersion')
                    }}</el-dropdown-item>
                    <el-dropdown-item command="history">{{ $t('ViewHistory') }}</el-dropdown-item>
                    <el-dropdown-item
                      command="compareVersions"
                      :disabled="!!scope.row.check_out_user_id"
                      >{{ $t('compareVersions') }}</el-dropdown-item
                    >
                    <el-dropdown-item
                      command="checkIn"
                      :disabled="
                        !scope.row.check_out_user_id || userInfo.sub !== scope.row.check_out_user_id
                      "
                      >{{ $t('checkIn') }}</el-dropdown-item
                    >
                    <el-dropdown-item
                      command="checkOut"
                      :disabled="!!scope.row.check_out_user_id"
                      >{{ $t('checkOut') }}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="position: absolute; bottom: 0; right: 0"
            background
            @size-change="getDynamicTableResult('referch')"
            @current-change="getDynamicTableResult"
            :current-page.sync="mainTableParam.pageno"
            :page-sizes="$pageSizeAll"
            :page-size.sync="mainTableParam.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNumberL"
            class="float-right"
          ></el-pagination>
        </div>
        <!-- 文件清单 -->
        <div v-else-if="tableType === 'filesList'" :style="{ flexGrow: 1 }" class="ml-20px">
          <el-table
            :data="filesListData"
            v-loading="listLoading"
            height="calc(100% - 48px)"
            style="position: absolute; top: 0; left: 0"
            :highlight-current-row="true"
            @selection-change="fileSelectionChange"
            @sort-change="filesListSortChange"
            row-key="id"
            stripe
            border
          >
            <el-table-column
              type="selection"
              :reserve-selection="true"
              width="55"
            ></el-table-column>
            <el-table-column :label="`${$t('seqNo')}`" type="index" width="60">
              <template slot-scope="scope">
                <span>
                  {{ scope.$index + 1 + (filesPageInfo.pageNo - 1) * filesPageInfo.pageSize }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              :label="`${$t('DocumentAssociation')}`"
              prop="isRelated"
              sortable
              width="100"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row.isRelated ? 'Y' : 'N' }}
              </template>
            </el-table-column>
            <el-table-column
              :label="`${$t('DocumentName')}`"
              prop="fileName"
              sortable
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              :label="`${$t('filesPath')}`"
              prop="path"
              sortable
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              :label="`${$t('uploadTime')}`"
              prop="createdTime"
              sortable
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              :label="`${$t('uploadUser')}`"
              prop="createdUser"
              sortable
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column :label="`${$t('operate')}`" fixed="right" width="150">
              <template slot-scope="scope">
                <el-button size="mini" @click="toDelete([scope.row.id])">{{
                  $t('delete')
                }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="float-right"
            style="position: absolute; bottom: 0; right: 0"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="filesPageInfo.pageNo"
            :page-sizes="$pageSizeAll"
            :page-size="filesPageInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="filesPageInfo.total"
          ></el-pagination>
        </div>
      </multipane>
    </el-card>
    <div class="tc c-g9 fz-16 p-10" v-if="false">{{ $t('NoDataNow') }}</div>
    <!-- 新增目录树文件夹 -->
    <el-dialog
      :title="`${$t('addFolder')}`"
      :visible.sync="dialogsFormVisible"
      :close-on-click-modal="false"
      @close="cancelOneRecord('PageAddData')"
      v-dialogDrag
    >
      <el-form :model="PageAddData" ref="PageAddData" :rules="PageAddDatarules">
        <el-form-item :label="`${$t('FolderName')}`" prop="name" :label-width="formLabelWidth">
          <el-input
            :placeholder="`${$t('BulkAddFolders')}`"
            type="textarea"
            v-model="PageAddData.name"
            auto-complete="off"
            maxlength="120"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelOneRecord('PageAddData')">{{ `${$t('Cancel')}` }}</el-button>
        <el-button :loading="addLoading" type="primary" @click="addFolder('PageAddData')">{{
          `${$t('save')}`
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑目录树文件夹 -->
    <el-dialog
      :title="`${$t('editFolder')}`"
      :visible.sync="dialogsEditVisible"
      :close-on-click-modal="false"
      @close="cancelRecord('PageEditData')"
      v-dialogDrag
    >
      <el-form
        :model="PageEditData"
        ref="PageEditData"
        :rules="PageEditDatarules"
        :label-width="formLabelWidth"
      >
        <el-form-item :label="`${$t('FolderName')}`" prop="name">
          <el-input type="text" v-model="PageEditData.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('FolderPath')}`">
          <el-select
            v-model.trim="PageEditData.path"
            filterable
            clearable
            :placeholder="`${$t('pleaseChoose')}`"
            style="width: 100%"
            popper-class="select-tree"
            ref="uploadSelectTree"
          >
            <el-option :label="PageEditData.path" :value="PageEditData.path" hidden></el-option>
            <el-tree
              v-if="dialogsEditVisible"
              :data="folderTree"
              :props="defaultTreeProps"
              node-key="id"
              :default-expanded-keys="defaultExpandedKey"
              :current-node-key="currentNodeKey"
              highlight-current
              @node-click="pathNodeClick"
              :expand-on-click-node="false"
              lazy
              :load="lazyNode"
            ></el-tree>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelRecord('PageEditData')">{{ `${$t('Cancel')}` }}</el-button>
        <el-button type="primary" @click="modifyFolder('PageEditData')">{{
          `${$t('save')}`
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 查看历史/版本比较 弹框 -->
    <el-dialog
      :title="dialogTitle"
      width="1000px"
      heigth="100%"
      :visible.sync="viewHistoryVisible"
      :close-on-click-modal="false"
      @close="closeViewHistory"
      v-dialogDrag
    >
      <el-table
        :data="historyTableData"
        v-loading="historyTableLoading"
        :highlight-current-row="true"
        height="420px"
        ref="historyTable"
        @selection-change="handleHistorySelectionChange"
        :key="viewType"
        border
      >
        <el-table-column v-if="viewType === 'compareVersions'" type="selection" width="55">
        </el-table-column>
        <el-table-column :label="`${$t('seqNo')}`" type="index" width="55"></el-table-column>
        <el-table-column
          :label="`${$t('documentCode')}`"
          prop="code"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          :label="`${$t('DocumentName')}`"
          prop="name"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          :label="`${$t('documentVersion')}`"
          prop="revision"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          :label="`${$t('updataTime')}`"
          prop="last_modified_time"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          v-if="viewType === 'viewHistory'"
          :label="`${$t('operate')}`"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-button
              :disabled="!$hasAccess('read')"
              @click="handleClickDocument(scope.row, 1, 'isHistory')"
              size="mini"
              >{{ $t('BrowsingDocuments') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px"
        background
        @size-change="historySizeChange()"
        @current-change="historyCurrentChange()"
        :current-page.sync="historyPageInfo.pageNo"
        :page-sizes="$pageSizeAll"
        :page-size.sync="historyPageInfo.pageSize"
        layout="->, total, sizes, prev, pager, next"
        :total="historyPageInfo.total"
      ></el-pagination>
      <div slot="footer" class="dialog-footer tc">
        <el-button v-if="viewType === 'compareVersions'" type="primary" @click="toCompare">
          比较
        </el-button>
        <el-button v-if="viewType === 'viewHistory'" type="primary" @click="closeViewHistory">{{
          $t('confirm')
        }}</el-button>
        <el-button @click="closeViewHistory">{{ $t('Cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增编辑弹框--新 -->
    <HandoverFormDialog
      v-if="handoverFormProps.dialogVisible"
      :handoverFormProps="handoverFormProps"
      @handoverFormEmit="handoverFormEmit"
    />
    <!-- 上传文件 -->
    <el-dialog
      :close-on-click-modal="false"
      @close="cancelUploadFile('uploadForm')"
      :visible.sync="isUploadDocFile"
      :title="`${$t('uploadFiles')}`"
      width="1400px"
      v-dialogDrag
    >
      <div v-show="!showProgress">
        <el-form :model="uploadForm" :rules="uploadFormRules" ref="uploadForm" label-width="100px">
          <el-row>
            <el-col :span="11">
              <el-form-item :label="`${$t('path')}`" prop="PathName">
                <el-select
                  v-model.trim="uploadForm.PathName"
                  filterable
                  clearable
                  :placeholder="`${$t('pleaseChoose')}`"
                  style="width: 100%"
                  popper-class="select-tree"
                  ref="uploadSelectTree"
                  @clear="clearHandle('upload')"
                >
                  <el-option
                    :label="uploadForm.PathName"
                    :value="uploadForm.PathName"
                    hidden
                  ></el-option>
                  <el-tree
                    v-if="isUploadDocFile"
                    :data="folderTree"
                    :props="defaultTreeProps"
                    node-key="id"
                    :default-expanded-keys="defaultExpandedKey"
                    :current-node-key="currentNodeKey"
                    highlight-current
                    @node-click="uploadNodeClick"
                    :expand-on-click-node="false"
                    :load="lazyNode"
                    lazy
                  ></el-tree>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5" v-if="uploadForm.isAddDocument">
              <el-form-item :label="`${$t('Categories')}`" prop="classId">
                <el-select
                  v-model="uploadForm.classId"
                  :placeholder="`${$t('pleaseSelect')}`"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in classTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('fileType')}`" prop="type">
                <el-radio v-model="uploadForm.type" :label="0" @input="changeFileType">{{
                  $t('file')
                }}</el-radio>
                <el-radio v-model="uploadForm.type" :label="1" @input="changeFileType">{{
                  $t('zipFile')
                }}</el-radio>
                <el-checkbox v-model="uploadForm.isAddDocument" @change="isAddDocumentChange">{{
                  $t('synchronouslyCreatingDocuments')
                }}</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="uploadForm.isAddDocument">
              <el-form-item
                :label="`${$t('parseFileNameAddDocument')}`"
                label-width="160px"
                prop="FileRegularExpressions"
              >
                <el-input
                  size="small"
                  clearable
                  v-model="uploadForm.FileRegularExpressions"
                  :placeholder="`${$t('enterRuleExpression')}`"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <NewUploadFile
          :initFiles="initFiles"
          @uploadConfirm="uploadFileOK"
          @uploadSuccess="uploadSuccess"
          :uploadValid="uploadValid"
          :uploadLoading="uploadLoading"
          :type="uploadForm.type"
          :standardId="standardId"
          :uploadForm="uploadForm"
          ref="uploadFile"
        ></NewUploadFile>
      </div>
      <el-row v-show="showProgress" type="flex" style="height: 414px" align="middle">
        <el-col :span="12" :offset="6">
          <span>{{ `${$t('fileUploadProcessing')}!` }}</span>
          <el-progress
            :stroke-width="10"
            :percentage="progressPercent"
            class="m-t-15"
          ></el-progress>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 高级查询 -->
    <advancedQueries
      v-if="advancedQueriesProps.dialogVisible"
      :advancedQueriesProps="advancedQueriesProps"
      @updateAdvancedQueries="updateAdvancedQueries"
    ></advancedQueries>
    <!-- 导入文档 -->
    <wiz-upload-file
      v-dialogDrag
      @refreshList="getDynamicTableResult('sizeChange')"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>
  </div>
</template>

<script type="text/ecmascript-6">
import { Base64 } from 'js-base64'
import { Multipane, MultipaneResizer } from 'vue-multipane'
import fnMixin from '@/assets/js/fnMixins'
import TagService from '@/services/tags'
import stdClassDataService from '@/services/bsApi/stdClassDataService'
// import $ from 'jquery'
import ApiMixinDocumentList from '@/assets/js/api/documentList'
import DocumentManagementService from '@/services/documentManagement'
import DocumentService from '@/services/DocumentService'
import stdClassListService from '@/services/stdClassListService'
import ApiMixinDocument from '@/assets/js/api/documents'
// import { getasync } from '@/api/article'
// import columnVisible from '@/components/ColumnVisible'
// import { getUrl, } from '@/api/config'
import FilterMixins from '@/assets/js/filters'
import qs from 'qs'
import NewUploadFile from './components/newUploadFile'
import selectStandardId from '../../components/selectStandardId'
import HandoverFormDialog from '../../components/handoverFormDialog'
import advancedQueries from '../../components/advancedQueries'


export default {
  name: 'handoverDocument',
  mixins: [ApiMixinDocumentList, FilterMixins, ApiMixinDocument, fnMixin],
  components: {
    Multipane,
    MultipaneResizer,
    NewUploadFile,
    // columnVisible,
    selectStandardId,
    HandoverFormDialog,
    advancedQueries,
  },
  watch: {
    standardId(newVal) {
      if (newVal) {
        this.mainTableParam.folderId = null
        this.getCurrentTree() // 加载目录树
        this.getDynamicTableHeaders()
        this.getDynamicTableResult()
        this.defaultExpandedKey = []
        this.currentNodeKey = ''
        this.uploadForm.PathName = ''
        this.uploadForm.FolderId = ''
        this.uploadForm.isAddDocument = true
        this.FolderName = ''
      }
    },
  },
  computed: {
    userInfo() {
      return Wiz.AuthHooks.GetUserInfo()?.profile
    },
    currentProject() {
      return this.$store.getters.currentProject || this.$store.getters['Sites/currentProject'] || {}
    },
    modelCenterVersion() {
      const version = _.find(this.systemParams, { parameterCode: 'modelCenterVersion' }) || {}
      return version.parameterValue
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = _.get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (!routerBase) {
        return ''
        // eslint-disable-next-line no-else-return
      } else if (routerBase && Array.isArray(routerBase)) {
        return routerBase.length ? `/${routerBase[0]}` : ''
      }
      return `/${routerBase}`
    },
    isSplitScreen() {
      const isSplitScreen = _.get(Wiz, 'globalSettings.globalConfig.isSplitScreen')
      return isSplitScreen
    }, // 浏览文档时是否使用分屏
    // 文件服务地址
    standardServer() {
      return Wiz.GetModuleConfig('legacy-resource')?.currentEnv?.VUE_APP_STANDARD_SERVER
    },
    // 文件预览服务地址
    filePreviewServer() {
      return Wiz.GetModuleConfig('legacy-resource')?.currentEnv?.VUE_APP_FILE_PREVIEW_SERVER
    },
    disabledBatchBtn() {
      return _.find(this.totalSelection, (item) => {
        return item.check_out_user_id
      })
    },
  },
  data() {
    const checkFileRegularExpressions = (rule, value, callback) => {
      if (!value || value.match(/^\{[a-zA-Z0-9_]+\}$/) || value.match(/^(?:\{[a-zA-Z0-9_]+\}'[^']+')+\{[a-zA-Z0-9_]+\}$/)) {
        callback()
      } else {
        callback(new Error(this.$t('enterRightRuleExpression')))
      }
    }
    return {
      isAdvanceQuery: false,
      condition: {
        conditionalModels: [],
        classIdsType: '',
        classId: ''
      },
      tableType: 'docList', // 表格类型
      isDocList: true, // 标识当前页面是否为文档列表
      isExpandAll: false, // 是否展开全部
      downloading: false,
      exportLoading: false,
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
      progressPercent: 1,
      showProgress: false,
      defaultExpandedKey: [], // 文档路径默认展开节点
      currentNodeKey: '', // 文档路径树当前选中
      isLazy: true,
      initFiles: [],
      // 主表格参数
      mainTableParam: {
        // 表格主数据请求参数
        keyWord: '',
        flag: 2,
        pageno: 1,
        pagesize: 15,
        classIds: [],
        folderId: '',
        isRecursion: true,
        searchItems: [],
        startTime: '',
        endTime: '',
        orderby: 'code', // 默认根据文档编码排序
        isAsc: true,
        category: [],
      },
      totalNumberL: null,
      id: [], // 表格勾选中的文档id集合
      treeStandBy: true, // 目录树显示与否
      treeData: {}, // 编辑目录树项的回显数据
      addLoading: false, // 新增编辑tab列表确定按钮加载状态
      uploadFileBol: false, // 控制文件上传的渲染
      uploadFileBol2: false, // 编辑文档控制文件上传渲染
      formLabelWidth: '100px',
      uploadForm: {
        // 上传文件表单
        FolderId: '00000000-0000-0000-0000-000000000000',
        PathName: '/',
        type: 0,
        isAddDocument: true,
        classId: '',
        FileRegularExpressions: ''
      },
      // 新增文件夹的校验
      PageAddDatarules: {
        name: [{ required: true, message: this.$t('PleaseFnterAFolderName'), trigger: 'change' }],
      },
      uploadFormRules: {
        // 上传文件的校验
        PathName: [{ required: true, message: this.$t('PleaseSelectAPath'), trigger: 'change' }],
        type: [{ required: true, message: '请选择文件类型', trigger: 'change' }],
        classId: [{ required: true, message: this.$t('PleaseSelectACategory'), trigger: 'change' }],
        FileRegularExpressions: [{ validator: checkFileRegularExpressions, trigger: 'blur' }]
      },
      // 编辑文件夹的校验
      PageEditDatarules: {
        name: [{ required: true, message: this.$t('PleaseFnterAFolderName'), trigger: 'change' }],
        path: [{ required: true, message: this.$t('PleaseEnterTheFolderPath'), trigger: 'change' }],
      },
      // 目录树的配置项
      defaultTreeProps: {
        children: 'childrens',
        label: 'name',
        isLeaf: 'isleaf',
      },
      dataList: [] /* 存放tab列表的数据 */,
      detailsData: {
        code: '',
        name: '',
        folderId: '',
        pathName: '',
        revision: '',
        planDate: '',
        actualDate: '',
        seqNo: 0,
        classId: '',
      } /* 存放tab编辑时表单详情的数据 */,
      listLoading: false, // tab数据加载状态
      isShowLeft: -1,
      isShowRight: -1,
      isShowIcon: 0,
      FoldersSrc: [], // 下拉选项路径集合
      FoldersSrcHandover: [], // 移交部分的下拉列表
      documentId: '', // tab当前项的id
      fileId: [], // 关联关系-文件id
      file: {}, // 关联关系-上传的文件
      searchData: [], // 远程搜索的数据
      timeout: null,
      tagId: '', // 位号id
      isShowAdd: false, // 是否显示添加位号
      successUrl: '',
      tagKeywords: '', // 搜索位号输入的内容
      aliasValue: '', // 添加关联关系-别名
      dialogsFormVisible: false,
      parentData: [],
      parentId: '', // 新增文件夹上级id
      currentNode: null, // 当前选中的目录树节点
      PageAddDataList: [], // 新增文件夹数组
      PageAddData: {
        // 新增文件夹对象
        name: '',
      },
      dialogsEditVisible: false, // 编辑目录树文件夹
      PageEditData: {
        // 编辑目录树字段
        name: '',
        path: '',
        id: '',
        parentId: '',
      },
      editid: '', // 编辑目录树时的当前id
      expandList: [], // 当前目录树展开项的集合
      initExpandList: [], // 初始化时目录树展开的集合
      addid: '', // 新增时当前的id
      isClick: false,
      excelName: ['文档清单模板', '文档清单导入结果', '文档清单导出文件'],
      FolderName: '', // 当前文件目录名称
      isSmall: true, // 判断是否小屏幕
      downloadProgressVisible: false, // 进度条显示与否
      downloadProgress: 0, // 下载进度条
      totalSelection: [], // 存放跨页勾选的项
      transFerSelection: [], // 过滤后的勾选数据
      changeDocList: [],
      currentTree: [], // 当前目录树数据
      treeKeyWord: '', // 目录树关键字搜索
      currentFlowId: '', // 当前流程id
      showSearchDialog: false, // 高级搜索弹框
      isUploadDocFile: false, // 上传文件显示与否
      columnVisible: ['code', 'name', 'className', 'revision', 'flagName'],
      columnVisibleOptions: [
        {
          value: 'code',
          label: 'fileCode',
        },
        {
          value: 'name',
          label: 'fileName',
        },
        {
          value: 'className',
          label: 'documentCategory',
        },
        {
          value: 'revision',
          label: 'Version',
        },
        {
          value: 'flagName',
          label: 'state',
        },
        {
          value: 'createdTime',
          label: 'creationTime',
        },
        {
          value: 'createdUser',
          label: 'createUser',
        },
        {
          value: 'lastModifiedTime',
          label: 'LastModified',
        },
        {
          value: 'lastModifiedUser',
          label: 'LastModifiedUser',
        },
        // {
        //   value: 'planDate',
        //   label: 'ScheduledDeliveryTime',
        // },
        // {
        //   value: 'actualDate',
        //   label: 'ActualDeliveryTime',
        // },
      ],
      startEquipmentList: [],
      endEquipmentList: [],
      hideTemplateAttr: [
        {
          code: 'lianlu',
          attr: ['lujin'],
        },
      ], // 需要隐藏显示的模板属性
      classTreeProps: { value: 'id', label: 'name', children: 'childrens' },
      docTreeData: [],
      docSearchName: '',
      docSearchNameList: [],
      classDocName: '',
      //  标准部分
      standardId: localStorage.getItem('standardId'),
      firstLoad: false,
      typeTreeData: [], // 类别数据
      typeList: [],
      currentTreeList: [],
      typeNodeKey: '', // 类别默认选中的节点
      typeExpandedKey: [], // 类别默认展开的节点
      attributeList: [],
      tagOrDocumentAttributes: [],
      // 上传
      imgExt: ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'tif'],
      viewUrl: '',
      uploadFileVisible: false,
      isFullScreen: false,
      uploadFileTitle: '上传',
      currentRow: null,
      fileExt: ['pptx', 'ppt', 'xlsx', 'xls', 'doc', 'docx', 'txt'], // 转pdf的文件格式
      rangeNum: 100,
      handleCode: '',
      disabledBtn: false,
      transitListCopy: [],
      currentDocRow: {},
      uploadLoading: false,
      sortName: '', // 排序的字段
      sortType: '', // 排序的方式 asc为升序, desc为降序
      isAdd: false, // 新增还是编辑
      opereateList: [],
      uploadId: '',
      browseItem: null, // 浏览文件
      currentCode: '',
      isImg: false,
      loadingFile: false,
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      isEdit: true,
      handoverFormProps: {
        dialogVisible: false, // form弹框显示状态
        standardId: localStorage.getItem('standardId'),
        tabs: [
          // form弹框tab显示
          { name: '文档', label: '1' },
          // { name: '关联关系', label: '3' },
          // { name: '关联文档', label: '4' },
        ],
        rowData: null,
        isShowClassType: true,
      },
      tableHeader: [],
      folderId: '', // 当前选择的目录树id
      folderTree: [], // 路径树
      dialogTitle: '',
      viewHistoryVisible: false,
      historyTableLoading: false,
      historyTableData: [],
      historyList: [],
      historyPageInfo: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      filesListData: [],
      filesPageInfo: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      fileSelections: [],
      classTypeList: [],
      fileListSortName: '',
      fileListSortType: '',
      delLoading: false,
      dropdownLoading: false,
      advancedQueriesProps: {
        dialogVisible: false,
        codeType: 'Document',
      },
      selectedHistoryRows: [],
      viewType: '',
    }
  },
  async created() {
    this.firstLoad = true
    // 判断是否切换项目
    const oldTenantId = localStorage.getItem('oldTenantId')
    const newTenantId = localStorage.getItem('TenantId')
    this.standardId = localStorage.getItem('standardId')
    if (this.standardId && oldTenantId === newTenantId) {
      await this.getCurrentTree()
      this.getTypeList()
      this.getDynamicTableHeaders()
      this.getDynamicTableResult()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$route.meta.notAlive = false
    next()
  },
  methods: {
    // 高级查询弹框
    toMoreSearch() {
      this.advancedQueriesProps.dialogVisible = true
      this.advancedQueriesProps.standardId = this.standardId
      this.advancedQueriesProps.classIds = this.mainTableParam.category
    },
    // 高级查询保存
    updateAdvancedQueries(val) {
      this.advancedQueriesProps.dialogVisible = val.dialogVisible
      if (!val.conditionalModels) return
      let classIdsType = ''
      this.mainTableParam.category.length === 1
        ? (classIdsType = 'singleClassId')
        : (classIdsType = 'multiClassId')
      this.getDynamicTableResult('search', val.conditionalModels, classIdsType, val.classId)
      this.isAdvanceQuery = true
      this.condition = {
        conditionalModels: val.conditionalModels,
        classIdsType,
        classId: val.classId
      }
    },
    searchList() {
      this.isAdvanceQuery = false
      if (this.isDocList) {
        this.getDynamicTableResult('sizeChange')
      } else {
        this.filesPageInfo.pageNo = 1
        this.getfilesTableList()
      }
    },
    // 文件清单按钮切换
    tableTypeChange() {
      this.isDocList = !this.isDocList
      if (this.isDocList) {
        this.tableType = 'docList'
        this.getDynamicTableHeaders()
        this.getDynamicTableResult()
      } else {
        this.tableType = 'filesList'
        this.filesPageInfo.pageNo = 1
        this.getfilesTableList()
      }
    },
    // 获取文件清单列表
    async getfilesTableList() {
      this.listLoading = true
      const params = {
        standardId: this.standardId,
        fileName: this.mainTableParam.keyWord,
        folderId: this.folderId,
        maxResultCount: this.filesPageInfo.pageSize,
        skipCount: this.filesPageInfo.pageSize * (this.filesPageInfo.pageNo - 1),
      }
      if (this.fileListSortName && this.fileListSortType) {
        params.sorting = `${this.fileListSortName} ${this.fileListSortType}`
      } else {
        delete params.sorting
      }
      const res = await TagService.getDocumentFileList(params)
      this.listLoading = false
      if (res && res.code === 0 && res.data) {
        this.filesListData = res.data
        this.filesPageInfo.total = res.totalCount
      } else {
        this.filesListData = []
        this.filesPageInfo.total = 0
      }
    },
    handleSizeChange(pageSize) {
      this.filesPageInfo.pageSize = pageSize
      this.getfilesTableList()
    },
    handleCurrentChange(pageNo) {
      this.filesPageInfo.pageNo = pageNo
      this.getfilesTableList()
    },
    // 删除文件
    toDeleteDocument(ids) {
      if (!ids.length) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('是否确定要删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        this.delLoading = true
        const res = await TagService.deleteDocumentFile(ids)
        this.delLoading = false
        if (res && res.code === 0) {
          this.$message.success('删除成功')
          this.getfilesTableList()
        }
      })
    },
    // 关闭历史查看弹框
    closeViewHistory() {
      this.viewHistoryVisible = false
    },
    // 查看历史
    toMoreList(command, row) {
      if (command === 'upgrade') {
        this.addCategory(row, 'upgrade')
      } else if (command === 'history') {
        this.viewHistoryVisible = true
        this.dialogTitle = this.$t('ViewHistory')
        this.viewType = 'viewHistory'
        this.getHistoryList(row)
      } else if (command === 'compareVersions') {
        this.viewHistoryVisible = true
        this.dialogTitle = '版本比较'
        this.viewType = 'compareVersions'
        this.getHistoryList(row)
        this.currentDocRow = row
      } else if (command === 'checkOut') {
        this.checkOutRow(row)
      } else if (command === 'checkIn') {
        this.addCategory(row, 'checkIn')
      }
    },
    checkOutRow(row) {
      this.$confirm('文档一经检出，将锁定，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        this.dropdownLoading = true
        const res = await DocumentManagementService.documentCheckInOut({
          checkType: 1,
          ids: [row.id],
          standardId: this.standardId,
        })
        this.dropdownLoading = false
        if (res && res.code === 0) {
          this.$message.success('检出成功')
          this.getDynamicTableResult()
        }
      })
    },
    // 版本比较多选
    handleHistorySelectionChange(selection) {
      if (selection.length > 2) {
        // 如果选择超过2个,保留最后选择的2个
        const lastTwoItems = selection.slice(-2)
        this.$nextTick(() => {
          // 清空表格选择
          this.$refs.historyTable.clearSelection()
          // 重新选中最后两个
          lastTwoItems.forEach((row) => {
            this.$refs.historyTable.toggleRowSelection(row, true)
          })
        })
        this.selectedHistoryRows = lastTwoItems
      } else {
        this.selectedHistoryRows = selection
      }
    },
    // 获取历史列表
    async getHistoryList(row) {
      this.historyTableData = []
      const historyType = this.viewType === 'viewHistory' ? 1 : null
      const params = {
        maxResultCount: this.historyPageInfo.pageSize,
        skipCount: this.historyPageInfo.pageSize * (this.historyPageInfo.pageNo - 1),
        standardId: this.standardId,
        cateCode: 'Document',
        filter: '',
        folderId: this.folderId,
        classIds: [row.class_id],
        historyType,
      }
      Object.keys(row).forEach((item) => {
        if (item.split('.').includes('code')) {
          params.filter = row[item]
        }
      })
      this.historyTableLoading = true
      const res = await DocumentManagementService.getHistoryData(params)
      this.historyTableLoading = false
      if (res && res.code === 0 && res.data) {
        this.historyList = _.cloneDeep(res.data)
        const newData = []
        res.data.forEach((item) => {
          const obj = {}
          Object.keys(item).forEach((val) => {
            let key = null
            val.indexOf('.') > -1 ? (key = val.split('.')[1]) : (key = val)
            obj[key] = item[val]
          })
          newData.push(obj)
        })

        this.historyTableData = newData
        this.historyPageInfo.total = res.totalCount
      }
    },
    historySizeChange(pageSize) {
      this.historyPageInfo.pageSize = pageSize
      this.getHistoryList()
    },
    historyCurrentChange(pageNo) {
      this.historyPageInfo.pageNo = pageNo
      this.getHistoryList()
    },
    // 版本比较
    toCompare() {
      if (this.selectedHistoryRows.length !== 2) {
        this.$message.warning('请选择两个版本进行比较')
        return
      }

      // 先关闭当前弹窗
      this.viewHistoryVisible = false

      // 使用nextTick确保弹窗完全关闭后再跳转
      this.$nextTick(() => {
        this.$router.push({
          path: './doc-view',
          query: {
            pageType: 'compareVersions',
            // 传递需要比较的两个版本数据
            compareData: JSON.stringify({
              version1: this.selectedHistoryRows[0],
              version2: this.selectedHistoryRows[1],
            }),
            standardId: this.standardId,
            documentId: this.currentDocRow.id,
          },
        })
      })
    },
    // 懒加载子节点
    async lazyNode(node, resolve) {
      this.isExpandAll = false
      let res = []
      if (node.data.id) {
        res = await this.loadNode(false, node.data.id)
      }
      resolve(res)
    },
    // 动态获取表头
    async getDynamicTableHeaders() {
      const res = await TagService.getDynamicTableHeaders({
        standardId: this.standardId,
        code: 'Document',
      })
      if (res && res.code === 0 && res.data) {
        this.tableHeader = res.data
      } else {
        this.tableHeader = []
      }
    },
    // 动态获取列表数据
    async getDynamicTableResult(type, conditionalModels, classIdsType, classId) {
      if (this.isAdvanceQuery) {
        conditionalModels = this.condition.conditionalModels
        classIdsType = this.condition.classIdsType
        classId = this.condition.classId
      }
      this.totalSelection = []
      if (type === 'sizeChange') {
        this.mainTableParam.pageno = 1
        this.mainTableParam.searchItems = []
        this.mainTableParam.startTime = ''
        this.mainTableParam.endTime = ''
      }
      if (type === 'referch') {
        this.mainTableParam.pageno = 1
      }
      if (!this.workBenchStatusVisible) {
        this.mainTableParam.flag = ''
      }

      let res = null
      this.listLoading = true
      if (classIdsType && classIdsType === 'singleClassId') {
        // 选中单个类别
        res = await stdClassDataService.getDynamicTableData({
          classId: this.mainTableParam.category[0],
          sorting: `${this.sortName} ${this.sortType}`,
          skipCount: (this.mainTableParam.pageno - 1) * this.mainTableParam.pagesize,
          maxResultCount: this.mainTableParam.pagesize,
          conditionalModels,
        }, conditionalModels && conditionalModels.length > 0 ? 'query' : '')
      } else {
        // 多类别或无类别
        const params = {
          standardId: this.standardId,
          classIds: this.mainTableParam.category,
          skipCount: (this.mainTableParam.pageno - 1) * this.mainTableParam.pagesize,
          maxResultCount: this.mainTableParam.pagesize,
          sorting: `${this.sortName} ${this.sortType}`,
          cateCode: 'Document',
          filter: this.mainTableParam.keyWord,
          folderId: this.mainTableParam.folderId,
          conditionalModels,
        }
        const queryValue = this.$route.query
        const queryKeys = Object.keys(queryValue)
        console.log('queryValue', queryValue)
        if (queryValue.title) {
          console.log('comein， out 了')
          return
        }
        if (!_.isEmpty(queryValue)) {
          if (queryKeys.includes('ShowClassicTop')) {
            delete queryValue.ShowClassicTop
          }
          if (queryKeys.includes('ShowClassicLeft')) {
            delete queryValue.ShowClassicLeft
          }
          params.columnValue = queryValue
        }
        if (conditionalModels && conditionalModels.length > 0) {
          params.classId = classId
        }
        res = await TagService.getDynamicTableResult(params, conditionalModels && conditionalModels.length > 0 ? 'query' : '')
      }
      this.listLoading = false
      if (res && res.code === 0 && res.data) {
        this.dataList = res.data
        this.totalNumberL = res.totalCount
      } else {
        this.dataList = []
        this.totalNumberL = 0
      }
    },
    // 文件清单列表多选
    fileSelectionChange(val) {
      this.fileSelections = val
    },
    // 批量删除
    toDelete(selections) {
      if (this.isDocList) {
        this.deleteDynamicData(selections || this.totalSelection)
      } else {
        let ids = []
        if (this.fileSelections.length > 0) {
          ids = this.fileSelections.map((item) => {
            return item.id
          })
        }
        this.toDeleteDocument(selections || ids)
      }
    },
    // 删除动态数据
    deleteDynamicData(rows) {
      if (rows.length > 0) {
        this.$confirm('是否确定要删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const params = []
          _.map(rows, (item) => {
            params.push({
              type: 3,
              standardId: this.standardId,
              dataId: item.id,
              classId: item.class_id ? item.class_id : null,
            })
          })
          this.delLoading = true
          const res = await DocumentManagementService.deleteDynamicData(params)
          this.delLoading = false
          if (res && res.code === 0) {
            this.$message.success('删除成功')
            this.getDynamicTableResult('sizeChange')
            this.$refs.multipleTable.clearSelection()
          }
        })
      } else {
        this.$message.warning('请选择要删除的数据')
      }
    },
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await DocumentManagementService.downloadTemplate({
        standardId: this.standardId,
        cateCode: 'Document',
        classIds: this.mainTableParam.category,
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '实体文档导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      formData.append('standardId', this.standardId)
      formData.append('cateCode', 'Document')
      formData.append('classId', '')
      formData.append('folderId', this.folderId)
      const res = await DocumentManagementService.importDynamicTableData(formData)
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '实体文档导入明细.xlsx',
          data: res,
        })
        this.getDynamicTableResult('sizeChange')
      }
      this.uploadFileProps.btnLoading = false
    },
    async updateStandardId(val) {
      this.standardId = val
      this.handoverFormProps.standardId = val
      await this.getCurrentTree()
      this.getTypeList()
      this.getDynamicTableHeaders()
      this.getDynamicTableResult()
    },
    // 新增弹框子组件传参
    handoverFormEmit(val) {
      if (val) {
        this.handoverFormProps.dialogVisible = val.dialogVisible
        this.getDynamicTableResult()
      }
    },
    handleCommand(command, node, data) {
      if (command === 'add') {
        this.append(data, node)
      } else if (command === 'edit') {
        this.modify(node, data)
      } else if (command === 'delete') {
        this.remove(node, data)
      }
    },
    // 点击文档列表当前行
    rowClick(row) {
      this.currentDocRow = row
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    // 文档路径清空
    clearHandle(type) {
      if (type === 'add') {
        this.form.PathName = ''
        this.form.FolderId = ''
      } else if (type === 'edit') {
        this.detailsData.folderId = ''
        this.detailsData.pathName = ''
      } else if (type === 'upload') {
        this.uploadForm.PathName = ''
        this.uploadForm.PathId = ''
      } else {
        this.transferForm.destinationFolderName = ''
        this.transferForm.destinationFolderId = ''
      }
    },
    uploadNodeClick(node) {
      this.uploadForm.FolderId = node.id
      this.uploadForm.PathName = node.path
      this.$refs.uploadSelectTree.blur()
    },
    pathNodeClick(node) {
      this.PageEditData.parentId = node.id
      this.PageEditData.path = node.path
      this.$refs.uploadSelectTree.blur()
    },
    nodeExpand(data) {
      this.expandList.push(data.folderId)
    },
    nodeCollapse(data) {
      this.expandList = _.filter(this.expandList, (i) => {
        return i !== data.folderId
      })
    },
    // 展开新增目录树弹框
    append(data, node) {
      if (data) {
        this.treeData = data
        this.addid = data.id
        this.parentData = data
        this.parentId = data.id
        this.currentNode = node
      } else {
        this.parentId = null
      }
      this.dialogsFormVisible = true
    },
    // 取消新增目录树操作
    cancelOneRecord(PageAddData) {
      this.$refs[PageAddData].resetFields()
      this.dialogsFormVisible = false
    },
    // 新增目录树节点
    async addFolder(PageAddData) {
      const pageName = this.PageAddData.name
      const pageNameList = pageName.split(/\n/)

      const valid = await this.$refs[PageAddData].validate()
      if (valid) {
        // 检查重复名称
        for (let i = 0; i < pageNameList.length; i += 1) {
          if (pageNameList[i] === pageNameList[i + 1]) {
            this.treeStandBy = true
            this.$message({
              type: 'warning',
              message: this.$t('TheTreeVodeNameCannotBeTheSamepleaseRe_enter'),
              duration: 2000,
            })
            return false
          }
          if (pageNameList[i] === '') {
            pageNameList.splice(i, 1)
          }
        }

        this.addLoading = true
        const params = _.map(pageNameList, (i) => {
          return {
            name: i,
            parentId: this.parentId ? this.parentId : '00000000-0000-0000-0000-000000000000',
            standardId: this.standardId,
          }
        })

        const res = await DocumentManagementService.addTreeNode(params)
        this.addLoading = false

        if (res && res.code === 0) {
          // 关闭弹窗并重置表单
          this.$refs[PageAddData].resetFields()
          this.dialogsFormVisible = false

          if (!this.parentId) {
            this.getCurrentTree() // 加载目录树
          } else {
            // 获取当前选中的节点
            const currentNode = this.$refs.documentMenuTree.getNode(this.parentId)
            if (currentNode) {
              // 重新加载当前节点的子节点
              const childrenData = await this.loadNode(false, this.parentId)
              // 更新当前节点的子节点数据
              this.$refs.documentMenuTree.updateKeyChildren(this.parentId, childrenData)
              // 展开当前节点
              currentNode.expanded = true
            }
          }

          this.$message.success('新增成功')

          // 更新表格数据
          this.getDynamicTableResult()
          return true
        }
      }
      return false
    },
    pathParentchange(item) {
      this.PageEditData.path = item.name
      this.PageEditData.parentId = item.id
    },
    // 展开编辑目录树弹框
    async modify(data) {
      this.dialogsEditVisible = true
      this.folderTree = await this.loadNode(true)
      this.editid = data.data.id
      this.treeData = data
      this.PageEditData.name = data.data.name
      this.PageEditData.path = data.data.path
      this.PageEditData.parentId = data.data.parentId
      this.defaultExpandedKey = [data.data.id]
      this.currentNodeKey = data.data.id
      // const query = getUrl(this.editid)
      // getasync(query).then((res) => {
      //   if (res.data && res.data.code === 0 && res.data.data) {
      //     this.PageEditData.name = res.data.data.name
      //     this.PageEditData.path = res.data.data.path
      //     this.PageEditData.parentId = res.data.data.parentId
      //     this.PageEditData.version = res.data.data.version
      //   }
      // })
    },
    // 取消编辑目录树节点的操作
    cancelRecord(PageEditData) {
      this.$refs[PageEditData].resetFields()
      this.dialogsEditVisible = false
    },
    // 编辑tree节点操作
    async modifyFolder(PageEditData) {
      this.$refs[PageEditData].validate((valid) => {
        if (valid) {
          const params = {
            id: this.editid,
            name: this.PageEditData.name,
            path: this.PageEditData.path,
            parentId: this.PageEditData.parentId,
            version: this.PageEditData.version,
          }
          this.apiDocumentList({
            method: 'editTree',
            params,
          }).then((res) => {
            if (res && res.code === 0) {
              this.$refs[PageEditData].resetFields()
              this.$message({
                type: 'success',
                message: '修改成功',
                duration: 2000,
              })
              this.dialogsEditVisible = false
              this.treeData.name = this.PageEditData.name
              this.treeData.path = this.PageEditData.path
              this.initExpandList = this.expandList
              this.treeStandBy = true
              this.getCurrentTree() // 加载目录树
              this.getDynamicTableResult() // 加载右侧文档列表
            } else {
              this.treeStandBy = true
            }
          })
        }
      })
    },
    // 删除tree节点操作
    async deleteTreeNode(ids, node, data) {
      let params = null
      if (ids) {
        params = {
          id: ids,
        }
        const res = await this.apiDocumentList({
          method: 'deleteTree',
          params,
        })
        if (res && res.code === 0) {
          const parent = node.parent
          const children = parent.childNodes || parent.data
          const index = children.findIndex((d) => {
            return d.key === data.folderId
          })
          children.splice(index, 1)
          this.$message({
            type: 'success',
            message: res.msg,
            duration: 2000,
          })
          this.expandList.push(data.parentId)
          this.getCurrentTree() // 加载目录树
          this.mainTableParam.folderId = null
          this.getDynamicTableResult('refresh') // 加载右侧文档列表
        }
      }
    },
    // 删除目录树节点操作
    async remove(node, data) {
      this.mainTableParam.folderId = data.id
      await this.getDynamicTableResult()
      const id = this.mainTableParam.folderId
      let num = 0
      if (this.dataList.length === 0) {
        this.$confirm(
          `${this.$t('AreYouSureYouWantToDeleteTheCorrespondingDirectory')}?`,
          this.$t('hint'),
          {
            confirmButtonText: this.$t('Sure'),
            cancelButtonText: this.$t('Cancel'),
            type: 'warning',
            beforeClose: async (action, instance, done) => {
              if (action === 'confirm') {
                instance.confirmButtonLoading = true
                num = num + 1
                if (num === 1) await this.deleteTreeNode(id, node, data)
                instance.confirmButtonLoading = false
                done()
              } else {
                done()
              }
            },
          }
        ).then(() => {})
      } else {
        this.$confirm(`${this.$t('DeleteDirectoriesAndDirectories')}?`, this.$t('hint'), {
          confirmButtonText: this.$t('Sure'),
          cancelButtonText: this.$t('Cancel'),
          type: 'warning',
        }).then(() => {
          this.deleteTreeNode(id, node, data)
        })
      }
    },
    // 列表转树
    listToTree(list) {
      const result = list.reduce((prev, curr, i, arr) => {
        curr.pathName = curr.path === '/' ? `/${curr.name}/` : `${curr.path}${curr.name}/`
        curr.children = arr.filter((v) => {
          return v.parentId === curr.id
        })
        if (
          curr.parentId === '00000000-0000-0000-0000-000000000000' ||
          curr.parentId === '' ||
          curr.parentId === null
        ) {
          prev.push(curr)
        }
        return prev
      }, [])
      return result
    },
    // 加载目录树数据
    async loadNode(isRoot, nodeId) {
      const res = await DocumentManagementService.getDocumentTree({
        standardId: this.standardId,
        filter: this.treeKeyWord,
        isRoot, // 是否查询根节点，true：查询根节点，false：查询子节点
        nodeId, // 节点id
      })
      if (res && res.code === 0 && res.data) {
        // this.currentTreeList = res.data
        // this.currentTree = res.data.length > 0 ? this.listToTree(res.data) : []
        return res.data
      }
      return []
    },
    // 搜索获取目录树数据
    async getCurrentTree() {
      if (this.treeKeyWord) {
        this.treeStandBy = false
        this.$nextTick(async () => {
          this.isExpandAll = true
          this.treeStandBy = true
          this.currentTree = await this.loadNode(false)
        })
      } else {
        // this.initExpandList = []
        // this.isLazy = true
        this.treeStandBy = false
        setTimeout(async () => {
          this.isExpandAll = false
          this.treeStandBy = true
          this.currentTree = await this.loadNode(true)
        }, 500)
      }
    },
    // 递归全部展开函数
    getAllOpen(val) {
      if (val.length) {
        _.forEach(val, (item) => {
          this.expandList.push(item.parentId)
          if (item.children.length) {
            this.getAllOpen(item.children)
          }
        })
      }
    },
    // 点击左侧目录树节点，获取右侧详情
    async handleDocNodeClick(data) {
      this.isAdvanceQuery = false
      this.isClick = true
      this.FolderName = data.path
      this.folderId = data.id
      this.mainTableParam.folderId = data.id
      this.uploadForm.FolderId = data.id
      this.uploadForm.PathName = data.path
      this.defaultExpandedKey = [data.id]
      this.currentNodeKey = data.id
      if (this.isDocList) {
        this.getDynamicTableResult('sizeChange')
      } else {
        this.filesPageInfo.pageNo = 1
        this.getfilesTableList()
      }
    },
    // 浏览文档
    async handleClickDocument(row, type, isHistory) {
      if (row.id) {
        const params = {
          id: row.id,
          standardId: this.standardId,
        }
        if (isHistory) {
          params.isVersion = true
          params.classId = row.class_id
        }
        const modelTypes = ['pr', 'pprj', 'rvm', 'fbx', 'vue', 'shp', 'zip', 'gltf', 'glb', 'las', 'prd', 'xml', 'obj', '3mf', 'blend', '3ds', 'stl', 'dae', 'fbxSkeleton', 'step', 'stp']
        const docBasicAttrRes = await DocumentService.findDocAttr(params)
        if (
          docBasicAttrRes &&
          docBasicAttrRes.code === 0 &&
          docBasicAttrRes.data &&
          docBasicAttrRes.data.defaultFileId?.includes('http')
        ) {
          window.open(docBasicAttrRes.data.defaultFileId)
          return
        }
        const fileRes = await DocumentService.getDocumentFileType({
          fileId: docBasicAttrRes.data.defaultFileId,
          standardId: this.standardId,
          isVersion: false,
        })
        if (fileRes && fileRes.code === 0 && fileRes.data) {
          const [newErr, newRes] = await DocumentService.getDocumentFiles({
            standardId: this.standardId || '', // 标准库id
            id: fileRes.data.documentId,
          })
          let modelInfoId = ''
          let textureInfoId = ''
          if (!newErr && newRes.status === 200 && newRes.data?.length) {
            let pprjIndex = -1
            let prIndex = -1
            let textureIndex = -1
            let modelsIndex = -1
            for (let i = 0; i < newRes.data.length; i += 1) {
              const newFileType = _.toLower(_.last(newRes.data[i].fileName.split('.')) || null)
              console.log(newFileType, 'newFileType')
              if (newFileType && newFileType === 'pprj' && pprjIndex === -1) {
                pprjIndex = i
              } else if (newFileType && newFileType === 'pr' && prIndex === -1) {
                prIndex = i
              } else if (newFileType && newFileType === 'zip' && textureIndex === -1) {
                textureIndex = i
              } else if (newFileType && modelTypes.includes(newFileType) && modelsIndex === -1) {
                modelsIndex = i
              }
            }
            // 同时存在多个pprj及多个pr,使用pprj或pr中排序最靠前的模型
            const modelIndexArr = _.filter([pprjIndex, prIndex, modelsIndex], (item) => {
              return item > -1
            })
            if (modelIndexArr?.length) {
              const modelIndex = _.min(modelIndexArr)
              const modelInfo = newRes.data[modelIndex]
              modelInfoId = modelInfo.fileId
              textureInfoId = textureIndex > -1 ? newRes.data[textureIndex].fileId : ''
            }
          }

          // resource原生预览
          const fileNameType = _.last(_.split(fileRes.data.fileNameOrigin, '.')) // 文件格式
          const fileType = _.toLower(fileNameType)
          if (!modelTypes.includes(fileType)) {
            // svg预览
            if (type === 1) {
              window.routerTrigger = 'noCache'
              this.dialogsUpGradeVisible = false
              this.showTransferDialog = false
              this.closeViewHistory()
              localStorage.setItem('currentViewFileTitle', docBasicAttrRes.data.name)
              console.log('进入浏览了')
              const query = {
                documentId: row.id,
                title: docBasicAttrRes.data.name,
                standardId: this.standardId,
                classId: row.class_id,
                isVersion: isHistory ? '1' : '0', // 是否是历史版本查看
                classCode: row.code,
                folderId: row.folder_id,
                defaultFileId: docBasicAttrRes.data.defaultFileId,
                showAnnotator: true,
              }
              if (window.__POWERED_BY_QIANKUN__) {
                console.log('this is low code', app, '使用app路由')
                this.$router.push(`${this.basePath}/legacy-resource/data-collection-manage/doc-view?${qs.stringify(query)}`)
              } else {
                this.$router.push({
                  path: './doc-view',
                  query
                })
              }
            }
            if (type === 2) {
              window.open(`/#/doc-view?documentId=${row.id}`)
            }
            return
          }
          console.log(fileType, 'fileType')
          if (modelTypes.includes(fileType)) {
            // 云渲染全屏版本
            if (type === 1) {
              const fullScreenParam = this.basePath
                ? {
                    ShowClassicTop: false,
                    ShowClassicLeft: false,
                  }
                : {}
              window.routerTrigger = 'noCache'
              // 云渲染全屏版本
              localStorage.setItem('currentViewFileTitle', docBasicAttrRes.data.name)
              const url = `${window.location.origin}/#${this.basePath}/fullscreen/model-doc-view${
          Wiz.globalSettings.dynamicModules.modules['legacy-resource']?.config?.isVulkan
            ? '-vk'
            : ''
        }/index?${qs.stringify({
                  modelInfoId,
                  textureInfoId,
                  documentId: row.id,
                  title: docBasicAttrRes.data.name,
                  standardId: this.standardId,
                  classId: row.class_id,
                  isVersion: isHistory ? '1' : '0', // 是否是历史版本查看
                  token: localStorage.getItem('authorization'),
                  ...fullScreenParam
                })
              }`
              window.open(url, '_blank')
            }
            if (type === 2) {
              const fullScreenParam = this.basePath
                ? 'ShowClassicTop=false&ShowClassicLeft=false&'
                : ''
              window.open(
                `/#${this.basePath}/fullscreen/model-doc-view${
          Wiz.globalSettings.dynamicModules.modules['legacy-resource']?.config?.isVulkan
            ? '-vk'
            : ''
        }/index?${fullScreenParam}documentId=${row.id}`
              )
            }
          }
        } else {
          this.$message.error('未关联默认文件')
        }
      }
    },
    // 当某一列的表头被点击是触发的事件
    handleHeaderClick(column) {
      if (column.property === undefined) {
        this.orderby = 'code'
      } else {
        this.orderby = column.property
      }
    },
    // 排序
    async sortChange(row) {
      let orderbytype = ''
      switch (row.order) {
        case 'ascending':
          orderbytype = 'asc'
          break
        case 'descending':
          orderbytype = 'desc'
          break
        default:
          orderbytype = ''
          break
      }
      this.sortName = row.prop
      this.sortType = orderbytype
      this.getDynamicTableResult()
    },
    async filesListSortChange(row) {
      let orderbytype = ''
      switch (row.order) {
        case 'ascending':
          orderbytype = 'asc'
          break
        case 'descending':
          orderbytype = 'desc'
          break
        default:
          orderbytype = ''
          break
      }
      this.fileListSortName = row.prop
      this.fileListSortType = orderbytype
      this.getfilesTableList()
    },
    // 获取当前选中的id
    selectionChange(val) {
      // _.forEach(this.totalSelection, (item) => {
      //   if (_.find(this.dataList, ['id', item.id])) {
      //     // 选中的列表中有存在项在当前表格中(val:注意每次返回的是当前页的选择项数组)
      //     this.totalSelection = _.difference(this.totalSelection, [item]) // 清空当前表格中已经选中的所有想
      //   }
      // })
      // this.totalSelection = [...this.totalSelection, ...val] // 先清空当前页的选择项在组合

      this.totalSelection = val
      // 获取id数组集合
      this.id = _.map(this.totalSelection, 'id')
      this.ducIds = _.map(_.filter(this.totalSelection, ['flag', 2]), 'id')
    },
    // 点击新增、编辑、升版按钮
    async addCategory(row, type = 'edit') {
      this.handoverFormProps.rowData = row
      this.handoverFormProps.dialogVisible = true
      this.handoverFormProps.folderId = this.folderId
      this.handoverFormProps.standardId = this.standardId
      if (row) {
        this.handoverFormProps.classId = row.class_id
        this.handoverFormProps.tabs = [
          // form弹框tab显示
          { name: '文档', label: '1' },
          { name: '关联关系', label: '5' },
          { name: '关联文件', label: '4' },
        ]
        this.handoverFormProps.type = type
      } else {
        this.handoverFormProps.tabs = [
          // form弹框tab显示
          { name: '文档', label: '1' },
        ]
        this.handoverFormProps.type = 'add'
        this.handoverFormProps.pageName = 'document'
      }
    },
    // 导出有数据excel表格
    async handleGetExcel() {
      if (this.id.length === 0) {
        // 导出全部
        this.$confirm('可能需要等待时间较长，请确认是否要继续', this.$t('hint'), {
          confirmButtonText: this.$t('Sure'),
          cancelButtonText: this.$t('Cancel'),
          type: 'warning',
        }).then(async () => {
          this.exportDynamicTableData()
        })
      } else {
        this.exportDynamicTableData()
      }
    },
    // 动态表格导出数据
    async exportDynamicTableData() {
      this.exportLoading = true
      const res = await DocumentManagementService.exportDynamicTableData({
        standardId: this.standardId,
        cateCode: 'Document',
        classIds: this.mainTableParam.category,
        ids: this.id,
        folderId: this.folderId,
        keywords: this.mainTableParam.keyWord,
      })
      this.exportLoading = false
      if (res) {
        this.downLoadExcel('实体文档导出结果.xlsx', res)
      }
    },
    // 下载文档关联文件
    async handleDownFile() {
      if (this.id.length > 0) {
        this.downloading = true
        const res = await DocumentManagementService.downloadDocumentFile({
          documentIds: this.id,
          standardId: this.standardId,
        })
        this.downloading = false
        if (res) {
          const blob = new Blob([res])
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '文档所关联文件.zip'
          link.click()
          window.URL.revokeObjectURL(link.href)
        } else {
          this.$message.warning(res.message)
        }
      } else {
        this.downloading = true
        const res = await DocumentManagementService.downloadDocumentFile({
          documentIds: this.id,
          standardId: this.standardId,
          isAll: true, // 下载全部
        })
        this.downloading = false
        if (res) {
          const blob = new Blob([res])
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '文档所关联文件.zip'
          link.click()
          window.URL.revokeObjectURL(link.href)
        } else {
          this.$message.warning(res.message)
        }
      }
    },
    // 点击上传文件
    async uploadDocFile() {
      this.initFiles = [] // 初始化上传文件组件数据的默认值
      this.uploadForm.FolderId = this.folderId || '00000000-0000-0000-0000-000000000000' // 初始化默认目录树id
      this.isUploadDocFile = true
      this.currentNodeKey = this.folderId ? this.folderId : ''
      this.uploadForm.PathName = this.FolderName ? this.FolderName : ''
      this.uploadForm.type = 0
      this.defaultExpandedKey = this.FolderName ? [this.folderId] : []
      this.folderTree = await this.loadNode(true)
      this.getTypeList()
    },
    changeFileType() {
      this.$refs.uploadFile.fileList = []
    },
    uploadValid() {
      let itValid = false
      this.$refs.uploadForm.validate((valid) => {
        itValid = valid
      })
      return itValid
    },
    // 点击确定按钮
    uploadFileOK(fileData) {
      const files = _.map(_.cloneDeep(fileData), (i) => {
        return i.raw
      })
      this.$refs.uploadForm.validate(async (valid) => {
        if (valid) {
          const formData = new FormData()
          formData.append('folderId', this.uploadForm.FolderId)
          formData.append('standardId', this.standardId)
          formData.append('isAddDocument', this.uploadForm.isAddDocument)
          formData.append('classId', this.uploadForm.classId)
          let res
          this.uploadLoading = true
          if (this.uploadForm.type === 0) {
            // 上传文件
            _.forEach(files, (item) => {
              formData.append('file', item)
            })
            res = await DocumentManagementService.uploadFiles(formData)
          } else {
            // 上传zip文件（用户上传压缩包.zip格式）
            _.forEach(files, (item) => {
              const folderName = item.name.split('/')[0]
              const file = new File([item], `${folderName}.zip`, { type: 'application/zip' })
              formData.append('file', file)
            })
            res = await DocumentManagementService.uploadZipFile(formData)
          }
          this.uploadLoading = false
          if (res) {
            this.downLoadBlob({
              name: '文件导入明细.xlsx',
              data: res,
            })
            this.isUploadDocFile = false
            this.getCurrentTree()
            this.getDynamicTableResult('sizeChange')
          }
        }
      })
    },
    // 上传文件成功回调函数
    uploadSuccess(val) {
      if (val) {
        this.cancelUploadFile()
        this.getCurrentTree()
        this.getDynamicTableResult('sizeChange')
      }
    },
    // 关闭弹框操作
    cancelUploadFile() {
      this.isUploadDocFile = false
    },
    handleColumnVisibleChanged(val) {
      this.columnVisible = val
      this.$nextTick(() => {
        this.$refs.multipleTable.doLayout()
      })
    },
    // 是否同步创建文档
    isAddDocumentChange(val) {
      // 判断类别字段是否必填
      if (val) {
        this.uploadFormRules.classId[0].required = true
      } else {
        this.uploadFormRules.classId[0].required = false
      }
    },
    // 获取类别下拉数据
    async getTypeList() {
      const parameter = {
        standard_id: this.standardId,
        data_type: 1,
        approve_status: 1,
        info_type: 1, // 文档
        catecode: 'Document', // 文档
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0) {
        this.classTypeList = res.data
      }
    },
  },
}
</script>

<style ref="stylesheet/scss" type="text/scss" lang="scss" scoped>

.icon-line-fullscreen {
  top: 23px;
  right: 45px;
}
.position-absolute {
  position: absolute;
}
.class-id-required /deep/ .el-form-item__label:before {
  content: '*';
  color: #f5222d;
  margin-right: 4px;
}
//覆盖element-ui 的样式
.block {
  border: 1px solid #eee;
  margin-top: 5px;
  .el-pagination {
    text-align: right;
  }
}
.content-contain-left {
  display: inline-block;
  width: 38%;
  border: 1px solid #ebeef5;
  overflow-y: auto;
  height: 95%;
}
.content-contain-right {
  float: right;
  width: 60%;
  border: 1px solid #ebeef5;
  height: 95%;
}
.relation-content {
  display: flex;
  display: -webkit-flex;
  box-sizing: border-box;
  overflow: hidden;
  .content-left {
    flex: 1;
    margin-right: 10px;
    .header-content {
      margin-bottom: 10px;
    }
  }
  .content-right {
    flex: 1;
    margin-left: 10px;
  }
}
.del-btn {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: solid 1px #444444;
  position: relative;
  float: right;
  color: #444444;
  .pos-a {
    position: absolute;
    right: 0px;
    top: 4px;
  }
}
.icon-color {
  background-color: #3b9543;
}
.disconnect-btn {
  width: 22px;
  height: 22px;
  position: relative;
  float: right;
  padding-right: 4px;
  cursor: pointer;
  .icon-size {
    width: 22px;
    height: 22px;
  }
  .pos-a {
    position: absolute;
    right: 4px;
    top: 0px;
  }
}
.deleteBtn {
  position: absolute;
  left: 3.5px;
  top: 3.5px;
}
.Treecol {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.editor-content {
  margin-top: 20px;
}
#document-management {
  .box-card {
    .el-card__header {
      padding: 15px !important;
    }
    .el-card__body {
      padding: 10px !important;
      height: calc(100% - 58px);
      overflow-y: auto;
    }
    .tree {
      // overflow-x: auto;
      width: 100%;
      height: calc(100% - 46px);
      overflow-y: auto;
      .el-tree {
        min-width: 100%;
        display: inline-block !important;
        .document-tree__action {
          width: 90px !important;
          .el-button + .el-button {
            margin-left: -2px !important;
          }
        }
      }
    }
  }
}
.multipane-resizer:before {
  content: '';
  position: absolute;
  top: 50%;
  left: 100%;
  width: 6px;
  height: 45px;
  border-left: 2px solid #d2d2d2;
  border-right: 2px solid #d2d2d2;
  transform: translate(-50%, -50%);
}

.multipane-resizer:hover:before {
  border-color: #999;
}
.span-button-group {
  .el-button + .el-button {
    margin-left: -2px !important;
  }
}
.handoverDialog {
  /deep/.el-tabs__content {
    height: 440px;
    overflow-y: scroll;
  }
}
.blueText {
  color: rgba(15, 93, 238, 0.897) !important;
}
.template-attr-tab .el-tabs__content {
  height: 276px !important;
  overflow-y: auto;
}
.advanced-search {
  cursor: pointer;
}
.search-tab {
  max-height: 300px;
  overflow-y: auto;
}
.history-btn {
  text-align: center;
}
// /deep/.el-table th > .cell {
//   font-weight: bold;
//   white-space: nowrap;
// }
.noShow {
  color: transparent;
}
// /deep/.el-table__fixed-header-wrapper,
// /deep/.el-table__header-wrapper {
//   height: 47px !important;
//   .el-table__header {
//     height: 100% !important;
//   }
// }
// /deep/.el-table__fixed-body-wrapper {
//   top: 47px !important;
// }
/deep/ .el-select__tags-text {
  display: inline-block;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/.el-tag__close {
  top: 0px !important;
}
.el-popper.doc_select-popper .el-select-dropdown__item {
  height: 100% !important;
  &.selected {
    background-color: #fff;
  }
}
.uploadDoc /deep/.el-upload-dragger {
  width: 505px !important;
  height: 230px !important;
}
.text-color-red {
  color: red;
}

</style>
